import { create } from 'zustand'
import type { FilterCategory } from '@/types'

interface FilterState {
  category: FilterCategory
  engineer: string
  period: number
  customDateFrom: string | null
  customDateTo: string | null
  setCategory: (c: FilterCategory) => void
  setEngineer: (e: string) => void
  setPeriod: (d: number) => void
  setCustomDateRange: (from: string, to: string) => void
  clearCustomDateRange: () => void
}

export const useFilterStore = create<FilterState>((set) => ({
  category: 'all',
  engineer: 'all',
  period: 30,
  customDateFrom: null,
  customDateTo: null,
  setCategory: (category) => set({ category }),
  setEngineer: (engineer) => set({ engineer }),
  setPeriod: (period) => set({ period, customDateFrom: null, customDateTo: null }),
  setCustomDateRange: (from, to) => set({ customDateFrom: from, customDateTo: to }),
  clearCustomDateRange: () => set({ customDateFrom: null, customDateTo: null }),
}))
